import React from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/features/auth/authSlice";
import { useNavigate, NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Form,
  Button,
  Card,
  Spinner,
  Alert,
  Nav,
} from "react-bootstrap";
import { useEffect } from "react";

const LoginSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email address.")
    .required("Email address is required to proceed."),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters long")
    .required("Password is required for security purposes."),
});



function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

useEffect(() => {
  document.querySelector('#google_translate_element').style.display = 'none';
},[])

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card style={{ width: "100%", maxWidth: "430px" }} className="p-4 shadow">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
          alt="abarka-logo"
          className="login-logo"
        />

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={LoginSchema}
          onSubmit={async (values, actions) => {
            try {
              const res = await dispatch(loginUser(values)).unwrap();
              toast.success(`Welcome, ${res.name}`);
              navigate("/dashboard");
            } catch (err) {
              toast.error(err.message || "Login failed");
            } finally {
              actions.setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <FormikForm>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Field name="email" type="email" as={Form.Control} />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Field name="password" type="password" as={Form.Control} />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />
              </Form.Group>
              <Form.Group className="mb-3 d-flex align-items-start">
                <Field
                  name="gdprConsent"
                  type="checkbox"
                  id="gdpr-consent"
                  className="mt-1 me-2"
                  required
                />
                <Form.Label>
                  I consent to the processing of my personal data according to
                  the
                  <Nav.Link
                    as={NavLink}
                    to="/privacy-policy"
                    className="privacy-policy-link"
                  >
                    Privacy Policy
                  </Nav.Link>
                </Form.Label>
              </Form.Group>
              <div className="d-grid">
                <Button
                  type="submit"
                  variant="primary"
                >
                  Login
                </Button>
              </div>
              <Form.Group className="mb-3 d-flex align-items-start mt-3">
                <Form.Label style={{ fontSize: 12, marginRight: 5 }}>
                  Contact your administrator if you need access
                </Form.Label>
                <Nav.Link
                  as={NavLink}
                  to="/forgot-password"
                  className="forgot-password"
                >
                  Forgot Password
                </Nav.Link>
              </Form.Group>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </Container>
  );
}

export default Login;
